export const buildCruisePageVisited = cruiseCode => ({
  type: "CruisePageVisited",
  cruiseCode
});
export const buildLastSeenProductDeleted = cruiseCode => ({
  type: "LastSeenProductDeleted",
  cruiseCode
});
export const buildBookingStarted = _ref => {
  let {
    sessionId,
    cruiseCode,
    returnUrl
  } = _ref;
  return {
    type: "BookingStarted",
    sessionId,
    cruiseCode,
    returnUrl
  };
};
export const buildBookingGuestsChanged = _ref2 => {
  let {
    sessionId,
    cruiseCode,
    adults,
    kids,
    returnUrl
  } = _ref2;
  return {
    type: "BookingGuestsChanged",
    sessionId,
    cruiseCode,
    adults,
    kids,
    returnUrl
  };
};
export const buildBookingFareSelected = _ref3 => {
  let {
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl
  } = _ref3;
  return {
    type: "BookingFareSelected",
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl
  };
};
export const buildBookingDeleted = () => ({
  type: "BookingDeleted"
});
export const buildBookingSuiteCategoryVisited = _ref4 => {
  let {
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl
  } = _ref4;
  return {
    type: "BookingSuiteCategoryVisited",
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl
  };
};
export const buildBookingSuiteCategorySelected = _ref5 => {
  let {
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory
  } = _ref5;
  return {
    type: "BookingSuiteCategorySelected",
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory
  };
};
export const buildBookingSuiteNumberSelected = _ref6 => {
  let {
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory,
    suiteNumber
  } = _ref6;
  return {
    type: "BookingSuiteNumberSelected",
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory,
    suiteNumber
  };
};
export const buildBookingGuestInfoVisited = _ref7 => {
  let {
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory,
    suiteNumber
  } = _ref7;
  return {
    type: "BookingGuestInfoVisited",
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory,
    suiteNumber
  };
};
export const buildBookingGuestInfoSubmitted = _ref8 => {
  let {
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory,
    suiteNumber
  } = _ref8;
  return {
    type: "BookingGuestInfoSubmitted",
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory,
    suiteNumber
  };
};
export const buildBookingCourtesyHoldCreated = _ref9 => {
  let {
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory,
    suiteNumber,
    bookingNumber,
    expirationDate
  } = _ref9;
  return {
    type: "BookingCourtesyHoldCreated",
    sessionId,
    cruiseCode,
    adults,
    kids,
    fare,
    flights,
    returnUrl,
    suiteCategory,
    suiteNumber,
    bookingNumber,
    expirationDate
  };
};
export const buildBookingCompleted = () => ({
  type: "BookingCompleted"
});